import { Component, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import * as _ from 'lodash'

import { BaseModalFormComponent } from 'core/forms'
import { Constants } from 'config'
import { Folder, FolderService } from 'models'

@Component({
  template: require('./folder-form.component.html'),
  selector: 'folder-form',
  styles: [require('./folder-form.component.sass')]
})

export class FolderFormComponent extends BaseModalFormComponent {
  private folder: Folder
  private folderWas: Folder

  @ViewChild('nameInput') private nameInputElRef: ElementRef

  @Output('afterCreate') afterCreateEmitter = new EventEmitter<Object>()
  @Output('afterUpdate') afterUpdateEmitter = new EventEmitter<Object>()
  @Output('afterDestroy') afterDestroyEmitter = new EventEmitter<Object>()

  constructor(protected folderService: FolderService) {
    super()
  }

  showNew(attributes: Object = {}) {
    if(!attributes['ancestry']) {
      throw '`ancestry` must be passed'
    }
    this.modal.show()
    this.folder = new Folder(attributes)
    this.buildForm()
  }

  showEdit(id: number) {
    this.modal.show()
    this.loading = true
    this.folderService.find(id).subscribe(
      data => {
        this.folder = data['folder']
        this.folderWas = _.cloneDeep(this.folder)
        this.buildForm()
        this.loading = false
      },
      error => {
        this.alertService.error(error)
      }
    )
  }

  protected onModalShown() {
    super.onModalShown()

    if(this.nameInputElRef && !this.folder.persisted()) {
      this.nameInputElRef.nativeElement.focus()
    }
  }

  protected onModalHidden() {
    super.onModalHidden()
    this.folder = null
    this.folderWas = null
  }

  protected sendForm() {
    this.loading = true
    this.folderService.save(this.folder).subscribe(
      data => {
        let eventData = { folder: data['folder'], folderWas: this.folderWas }
        this.folder.persisted() ? this.afterUpdateEmitter.emit(eventData) : this.afterCreateEmitter.emit(eventData)
        this.alertService.success('Папка сохранена')
        this.hide()
      },
      error => {
        this.loading = false
        this.alertService.error(error)
      }
    )
  }

  protected buildForm() {
    this.form = new FormGroup({
      name: new FormControl(this.folder.name, this.validators.required())
    })
  }

  protected canDestroyWithoutContents(): boolean {
    return this.folder.depth() > 1
  }

  protected destroyConfirm() {
    this.confirmService.show({
      title: 'Удалить папку?',
      confirmBtnText: 'Удалить',
      confirmFn: this.destroy.bind(this)
    })
  }

  protected destroyWithContentsConfirm() {
    this.confirmService.show({
      title: 'Удалить папку с содержимым?',
      confirmBtnText: 'Удалить',
      confirmFn: this.destroyWithContents.bind(this)
    })
  }

  protected destroy() {
    this.loading = true
    this.folderService.destroy(this.folder).subscribe(
      data => {
        let eventData = { folder: data['folder'], folderWas: this.folderWas }
        this.afterDestroyEmitter.emit(eventData)
        this.alertService.success('Папка удалена')
        this.hide()
      },
      error => {
        this.loading = false
        this.alertService.error(error)
      }
    )
  }

  protected destroyWithContents() {
    this.loading = true
    this.folderService.destroyWithContents(this.folder).subscribe(
      data => {
        let eventData = { folder: data['folder'], folderWas: this.folderWas }
        this.afterDestroyEmitter.emit(eventData)
        this.alertService.success('Папка удалена')
        this.hide()
      },
      error => {
        this.loading = false
        this.alertService.error(error)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/common/folder-tree/folder-form.component.ts